// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 367 ? "d4783096" : chunkId) + "." + {"268":"ca0d188b899e0cdd","367":"6fc920eb2a64ad81","647":"77f121af7757d12b"}[chunkId] + ".js";
};